import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const painPoints = [
  'I hate being blindsided by a customer canceling when I thought they were healthy.',
  "I'm always stressing about whether we're paying attention to the right accounts.",
  "My team is stretched, and I'm not confident the right customers are getting our attention.",
  'As we grow, it feels like we need more CS people just to keep track of which customers might be slipping.',
  'The worst part is having to explain how a customer churned when everything looked fine.',
];

type ProblemSectionProps = {
  onApplyClick: () => void;
};

export default function ProblemSection({ onApplyClick }: ProblemSectionProps) {
  return (
    <section className="py-24 px-6 bg-dark-gray-b border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="max-w-3xl mb-12">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            Lean teams managing hundreds of accounts lose visibility into churn risk.
          </h2>
          <p className="landing-prose">If you own churn risk, these probably sound familiar:</p>
        </LandingReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-16 items-stretch">
          {painPoints.map((quote, index) => (
            <LandingReveal
              key={quote}
              delayClass={index % 2 === 0 ? 'landing-delay-1' : 'landing-delay-2'}
              className={
                index === painPoints.length - 1
                  ? 'h-full sm:col-span-2 sm:w-[calc(50%-0.5rem)] sm:justify-self-center lg:col-span-1 lg:w-auto'
                  : 'h-full'
              }
            >
              <blockquote className="landing-quote-bar">
                <p className="text-primary text-base leading-relaxed">
                  <span className="landing-quote-mark mr-1">&ldquo;</span>
                  {quote}
                  <span className="landing-quote-mark ml-1">&rdquo;</span>
                </p>
              </blockquote>
            </LandingReveal>
          ))}
        </div>

        <LandingReveal>
          <div
            className="landing-card p-8 md:p-12 text-center border-primary"
            style={{ backgroundColor: 'rgba(0, 185, 255, 0.04)' }}
          >
            <h3 className="landing-headline text-2xl md:text-3xl font-bold leading-tight mb-5">
              Managing hundreds of customers with a lean CS team?
            </h3>
            <p className="landing-prose max-w-3xl mx-auto mb-8">
              ChurnSignal is designed for growing B2B SaaS companies where a lean CS team is responsible for more
              customers than they can realistically monitor.
            </p>
            <button
              type="button"
              onClick={onApplyClick}
              className="inline-flex px-8 py-4 rounded-lg font-semibold transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
              style={{
                backgroundColor: '#fafafa',
                color: '#0e1c2a',
                boxShadow: '0 8px 32px rgba(250, 250, 250, 0.1)',
              }}
            >
              Join the waitlist
            </button>
          </div>
        </LandingReveal>
      </div>
    </section>
  );
}
